import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.2493 9C15.2493 12.4518 12.4511 15.25 8.99935 15.25C5.54757 15.25 2.74935 12.4518 2.74935 9C2.74935 5.54822 5.54757 2.75 8.99935 2.75C12.4511 2.75 15.2493 5.54822 15.2493 9ZM17.3327 9C17.3327 13.6024 13.6017 17.3333 8.99935 17.3333C4.39698 17.3333 0.666016 13.6024 0.666016 9C0.666016 4.39762 4.39698 0.666664 8.99935 0.666664C13.6017 0.666664 17.3327 4.39762 17.3327 9ZM5.71396 5.71461C6.05567 5.3729 6.60969 5.3729 6.9514 5.71461L8.99935 7.76256L11.0473 5.71461C11.389 5.3729 11.943 5.3729 12.2847 5.71461C12.6264 6.05632 12.6264 6.61034 12.2847 6.95205L10.2368 9L12.2847 11.0479C12.6264 11.3897 12.6264 11.9437 12.2847 12.2854C11.943 12.6271 11.389 12.6271 11.0473 12.2854L8.99935 10.2374L6.9514 12.2854C6.60969 12.6271 6.05567 12.6271 5.71396 12.2854C5.37226 11.9437 5.37226 11.3897 5.71396 11.0479L7.76191 9L5.71396 6.95205C5.37226 6.61034 5.37226 6.05632 5.71396 5.71461Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }